import { configureStore } from '@reduxjs/toolkit'
import menuSlice from '@/redux-store/slices/menuItemSlice/menuItemSlice'
import caseManagementSlice from '@/redux-store/slices/caseManagementSlice/caseManagementSlice'
import siteListSlice from '@/redux-store/slices/siteListSlice/siteListSlice'
import eventsSlice from '@/redux-store/slices/eventsSlice/eventsSlice'
import trafficDataSlice from '../slices/trafficDataSlice/trafficDataSlice'
import selectedOptionsSlice from '../slices/dropdownOptionsSlice/dropdownOptionsSlice'
import recentAlertsSlice from '../slices/recentAlertsSlice/recentAlertsSlice'
import reportsSlice from '../slices/reportsSlice/reportsSlice'
import modalSlice from '../slices/modalSlice/modalSlice'
import loadingStyleSlice from '../slices/loadingStyleSlice/loadingStyleSlice'
import widgetResetSlice from '../slices/widgetResetSlice/WidgetResetSlice'
import orderSlice from '../slices/orderSlice/orderSlice'
import serviceInventorySlice from '../slices/serviceInventorySlice/serviceInventorySlice'
import sitesOverviewSlice from '../slices/OverviewSlice/SitesOverViewSlice'
import logoSlice from '../slices/logoSlice/logoSlice'
import userTablesSlice from '../slices/UserTablesSlice/userTablesSlice'
export const store = configureStore({
  reducer: {
    modal: modalSlice,
    menu: menuSlice,
    userTables: userTablesSlice,
    caseManagement: caseManagementSlice,
    siteList: siteListSlice,
    eventsList: eventsSlice,
    trafficData: trafficDataSlice,
    dropdownOptionsClicked: selectedOptionsSlice,
    recentAlerts: recentAlertsSlice,
    reports: reportsSlice,
    loadingStyle: loadingStyleSlice,
    widgetReset: widgetResetSlice,
    orders: orderSlice,
    serviceInventory: serviceInventorySlice,
    sitesOverview: sitesOverviewSlice,
    logo: logoSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
